import { createSelector } from "reselect";

export const validatorsObjectPropertiesSelector = createSelector(
    state => state.services.validatorsObjectProperties,
    state => state
);